/* =========================================================
   sports&deco — Parser GPX (format XML standard, Strava export)
   Retourne un objet Activity normalisé : voir stats.js
   ========================================================= */

function parseGPX(text) {
  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const err = xml.querySelector('parsererror');
  if (err) throw new Error('GPX: XML invalide');

  const trkpts = Array.from(xml.getElementsByTagName('trkpt'));
  const rtepts = Array.from(xml.getElementsByTagName('rtept'));
  const wpts   = Array.from(xml.getElementsByTagName('wpt'));
  const points = trkpts.length ? trkpts : (rtepts.length ? rtepts : wpts);

  if (!points.length) throw new Error('GPX: aucun point trouvé');

  const samples = points.map((p) => {
    const lat = parseFloat(p.getAttribute('lat'));
    const lon = parseFloat(p.getAttribute('lon'));
    const eleEl = p.getElementsByTagName('ele')[0];
    const timeEl = p.getElementsByTagName('time')[0];
    return {
      lat,
      lon,
      ele: eleEl ? parseFloat(eleEl.textContent) : null,
      time: timeEl ? new Date(timeEl.textContent) : null,
    };
  }).filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lon));

  const nameEl = xml.querySelector('trk > name, rte > name, metadata > name');
  const typeEl = xml.querySelector('trk > type, type');

  return {
    sourceFormat: 'gpx',
    name: nameEl ? nameEl.textContent.trim() : null,
    sportRaw: typeEl ? typeEl.textContent.trim() : null,
    samples,
  };
}
